import zod from "zod";
import { date, uuid } from "./common";
import { contextInstanceSchema } from "./contextInstance";
import { activeStepSchema, stepTimeSchema } from "./steps";

const processInstanceOrderSchema = zod.object({
    id: uuid,
    number: zod.string().max(255),
    status: zod.string(),
    transaction: zod.object({
        id: uuid,
        status: zod.string(),
        billId: zod.string(),
    }),
});

export const createProcessInstancePropsSchema = zod.object({
    productId: uuid,
});

export const getProcessInstancePropsSchema = zod.object({
    processInstanceId: uuid,
});

export const updateProcessInstanceFieldPropsSchema = zod.object({
    processInstanceId: uuid,
    variableId: uuid,
    value: zod.string(),
});

const processInstanceSchema = zod.object({
    id: uuid,
    processId: uuid,
    activeStepId: uuid,
    createdAt: date,
    updatedAt: date,
    contextInstance: contextInstanceSchema,
    // stepTimes: zod.array(stepTimeSchema),
    activeStep: activeStepSchema,
    order: processInstanceOrderSchema,
  });

export type ProcessInstanceOrderType = zod.infer<typeof processInstanceOrderSchema>;
export type CreateProcessInstancePropsType = zod.infer<typeof createProcessInstancePropsSchema>;
export type GetProcessInstancePropsType = zod.infer<typeof getProcessInstancePropsSchema>;
export type ProcessInstanceType = zod.infer<typeof processInstanceSchema>;
export type UpdateProcessInstanceFieldPropsType = zod.infer<typeof updateProcessInstanceFieldPropsSchema>;
